import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

import { historyScopeAtom, stampCardSorterAtom } from '../../../atoms/stampAtoms';

function useStampNote() {
    const sorter = useAtomValue(stampCardSorterAtom);
    const scope = useAtomValue(historyScopeAtom);

    const { data } = useQuery(queries.stamps.cardList(sorter));
    const card = data?.cards
        ?.find((it) => {
            if (scope?.targetScope === 'SHOP') {
                return scope.shopId && it.shopId === scope.shopId;
            }
            if (scope?.targetScope === 'SHOP_GROUP') {
                return scope?.shopGroupId && it.shopGroupId === scope?.shopGroupId;
            }
            return scope?.targetScope === 'PROJECT';
        });

    return card?.note;
}

export default useStampNote;
